const $ = require('jquery');

/**
 * Default configuration
 *
 * @type {Object}
 */
const DEFAULT_CONFIG = {
  edge: 'top',
  duration: 500,
  easing: 'swing',
};

/**
 * Create a plugin that smoothly scrolls to the element it's been assigned to
 *
 * @param {Object} opts - Options
 * @return {void};
 *
 * ---------------------------------------------------------------------------
 *
 * @example
 * $('.some-element').smoothScrollTo();
 *
 * @example
 * $('.some-element').smoothScrollTo();
 */
$.fn.smoothScrollTo = function smoothScrollTo(opts = {}) {
  const config = Object.assign({}, DEFAULT_CONFIG, opts);
  const headerHeight = $('header.header').outerHeight();

  // console.log(this);

  let position = $(this).position().top;

  if (config.edge === 'bottom') {
    position += this.outerHeight();
  }

  $('html, body').animate(
    { scrollTop: position + headerHeight },
    config.duration,
    config.easing,
  );
};

/**
 * Attach the plugin to all page-internal links
 */
$(document).on('click', 'a[href^="#"]:not(".no-scroll")', evt => {
  // evt.preventDefault();

  const targetId = $(evt.currentTarget).attr('href');

  if (targetId === '#') {
    return;
  }

  const $target = $(targetId);
  $target.smoothScrollTo({ duration: 1000 });
});

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
